/**
 * Marketing image presets for different upload contexts.
 * Each preset defines aspect ratio, dimensions, and allowed configurations.
 */

export interface ImagePreset {
  readonly label: string;
  readonly aspectRatio: number;
  readonly width: number;
  readonly height: number;
  readonly cropLabel: string;
}

export const IMAGE_PRESETS = {
  product: {
    label: "Photo produit",
    aspectRatio: 1,
    width: 1000,
    height: 1000,
    cropLabel: "Carré (1:1)",
  },
  hero: {
    label: "Slide héro",
    aspectRatio: 16 / 9,
    width: 1920,
    height: 1080,
    cropLabel: "Paysage (16:9)",
  },
  brand: {
    label: "Logo marque",
    aspectRatio: 1,
    width: 400,
    height: 400,
    cropLabel: "Carré (1:1)",
  },
  "brand-cover": {
    label: "Couverture marque",
    aspectRatio: 16 / 9,
    width: 1920,
    height: 1080,
    cropLabel: "Paysage (16:9)",
  },
  banner: {
    label: "Bannière marketing",
    aspectRatio: 16 / 9,
    width: 1200,
    height: 675,
    cropLabel: "Paysage (16:9)",
  },
  "flash-sale": {
    label: "Vente flash",
    aspectRatio: 16 / 9,
    width: 1200,
    height: 675,
    cropLabel: "Paysage (16:9)",
  },
  email: {
    label: "Newsletter",
    aspectRatio: 600 / 400,
    width: 600,
    height: 400,
    cropLabel: "Email (3:2)",
  },
  bundle: {
    label: "Pack / Bundle",
    aspectRatio: 4 / 3,
    width: 800,
    height: 600,
    cropLabel: "Standard (4:3)",
  },
} as const;

export type PresetKey = keyof typeof IMAGE_PRESETS;

/**
 * CIEDA brand filter presets for consistent visual identity.
 */
export const CIEDA_FILTERS = {
  "CIEDA Warm": {
    brightness: 5,
    contrast: 8,
    saturation: 12,
    warmth: 15,
  },
  "Clean White": {
    brightness: 10,
    contrast: 5,
    saturation: -5,
    warmth: -5,
  },
  Vibrant: {
    brightness: 3,
    contrast: 12,
    saturation: 25,
    warmth: 5,
  },
  Terracotta: {
    brightness: 0,
    contrast: 10,
    saturation: 8,
    warmth: 25,
  },
} as const;

export type FilterName = keyof typeof CIEDA_FILTERS;
